import { render, staticRenderFns } from "./DelayImportFromUtin.vue?vue&type=template&id=4490ca76"
import script from "./DelayImportFromUtin.vue?vue&type=script&lang=js"
export * from "./DelayImportFromUtin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports